import type { ProductGroupBy } from '@/api/bi';
import { cn } from '@/lib/cn';

const OPTIONS: { value: ProductGroupBy; label: string }[] = [
  { value: 'brand', label: 'Brand' },
  { value: 'category_group', label: 'Group' },
  { value: 'category', label: 'Category' },
  { value: 'subcategory', label: 'Sub-cat' },
  { value: 'product', label: 'SKU' },
];

interface DimensionToggleProps {
  value: ProductGroupBy;
  onChange: (v: ProductGroupBy) => void;
}

/** Pill segmented control choosing the grouping dimension for mix/quadrant/leaderboard. */
export function DimensionToggle({ value, onChange }: DimensionToggleProps) {
  return (
    <div
      role="group"
      aria-label="Group by"
      className="inline-flex items-center gap-0.5 rounded-md border border-border bg-surface p-0.5 text-[11px]"
    >
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          aria-pressed={value === o.value}
          className={cn(
            'press inline-flex h-6 items-center rounded-sm px-2 font-medium transition-colors focus-ring',
            value === o.value
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:bg-muted hover:text-foreground',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
